export default __webpack_public_path__ + "static/media/prototype1.75d8ce78.svg";